import type { RateData } from "utils/grow";
import { formatGrowRates } from "utils/grow";

export const getStaticStakingRates = async () => {
  const staticStakingRateData = (await import("_data/staking-rates.json"))
    .default;

  const { prices, apys, rates } = staticStakingRateData as any as RateData;
  return formatGrowRates({ prices, apys, rates });
};
